const isDev = process.env.NODE_ENV === "development";
//  || window.location.pathname.endsWith('test');

/**
 * @param input string
 * @param postData object
 * @return Promise<object>
 */
function makeRequest(input, postData) {
  let urlBase = "";
  if (isDev) {
    console.log(input, postData);
    urlBase = "http://shopulm.netz.indianer";
  }

  const handleResponse = response => {
    if (isDev) {
      console.log(response);
    }
    return response.json().then(json => {
      if (isDev) {
        console.log(json);
      }
      return json;
    });
  };

  if (!Api.CSRF_TOKEN) {
    return fetch(urlBase + "/plenigo_api/csrf", {
      credentials: isDev ? "same-origin" : "include"
    })
      .then(handleResponse)
      .then(body => {
        if (body && "_token" in body) {
          Api.CSRF_TOKEN = body["_token"];
          return makeRequest(input, postData);
        }
        throw body;
      });
  }

  const formData = new FormData();
  formData.append("_token", Api.CSRF_TOKEN);
  formData.append("_captcha", Api.CAPTCHA);

  const paperMatch = window.location.pathname.match(/^\/(.+)\/.+$/);
  if (paperMatch.length >= 2) {
    formData.append("_paper", paperMatch[1]);
  }
  Object.keys(postData).forEach(key => {
    formData.append(key, postData[key]);
  });

  return fetch(urlBase + input, {
    method: "post",
    body: formData,
    credentials: isDev ? "same-origin" : "include"
  }).then(handleResponse);
}

export default class Api {
  static CSRF_TOKEN = undefined;
  static CAPTCHA = undefined;

  static login(data) {
    return makeRequest("/plenigo_api/login", data);
  }

  static registration(data) {
    return makeRequest("/plenigo_api/registration", data);
  }

  static checkLogged(data) {
    return makeRequest("/plenigo_api/checkLogged", data);
  }

  static userPersonalData(data) {
    return makeRequest("/plenigo_api/userPersonalData", data);
  }

  static userUpdate(data) {
    return makeRequest("/plenigo_api/userUpdate", data);
  }
}
